import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import Pusher from "pusher-js";
import { format } from "date-fns";
import AttachmentDownloadClient from "./attachment_download_client";
import {
  clientSendMessage,
  setInput,
  addClientMessage,
  fetchClientMessages,
} from "../slice/clientChatSlice";
import "../style/clientChat-style.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const ClientChat = () => {
  const { id, type, chatId: urlChatId } = useParams();
  const location = useLocation();
  const messagesEndRef = useRef(null);

  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");

  console.log("name", name);

  const dispatch = useDispatch();
  const { messages, input, loading, error, chatId: reduxChatId } = useSelector((state) => state.clientChat);
  const navigate = useNavigate();
  const [localChatId, setLocalChatId] = useState(urlChatId || null);
  const [isSending, setIsSending] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const scrollToBottom = () => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
    useEffect(() => {
      scrollToBottom();
    }, [messages]);

    console.log("messages",messages);

  useEffect(() => {
  if (!urlChatId && reduxChatId) {
    setLocalChatId(reduxChatId);
    navigate(`/client/chat/${type}/${id}/${reduxChatId}`, { replace: true });
  }
}, [reduxChatId, urlChatId, navigate, id, type]);

  const clientToken = localStorage.getItem("client_access_token");
  const token = clientToken;
  const currentUserId = localStorage.getItem("user_id");
  const currentUserType = "Icommunetech\\Client\\Models\\Client";
  // const to_type = "Icommunetech\\Provider\\Models\\Provider";
  const to_type = type === "admin"
    ? "App\\Models\\User"
    : "Icommunetech\\Provider\\Models\\Provider";

  useEffect(() => {
    if (token && id) {
      dispatch(fetchClientMessages({ token, id, type }));
    }
  }, [dispatch, id, token]);

  useEffect(() => {
    if (!localChatId) return;
    Pusher.logToConsole = true;
    const pusher = new Pusher("71055cc21a087085dc31", {
      cluster: "ap2",
      forceTLS: true,
      authEndpoint: `${BACKEND_URL}/pusher/auth`,
    });

    const channel = pusher.subscribe(`private-chat_${localChatId}`);

    channel.bind("App\\Events\\MessageSent", (data) => {
      const isOwnMessage =
        data.message.from_id.toString() === currentUserId &&
        data.message.from_type === currentUserType;

      const isRelevantMessage =
        data.message.to_id.toString() === currentUserId &&
        data.message.to_type === currentUserType &&
        data.message.from_id.toString() === id &&
        data.message.from_type === to_type;

      if (!isOwnMessage && isRelevantMessage) {
        dispatch(
          addClientMessage({
            id: data.message.id,
            text: data.message.message,
            sender: "other",
            timestamp: data.message.created_at, // or updated_at, depending on backend
            file_path: data.message.file_path || null,
            file_name: data.message.file_name || null,
          })
        );
      }
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [localChatId, dispatch, id, currentUserId, currentUserType, to_type]);

  const handleSend = () => {
    if (input.trim() === "" && !selectedFile) return;

setIsSending(true);
    dispatch(clientSendMessage({ input, id, to_type, file: selectedFile, token }))
    .then(() => {
          dispatch(fetchClientMessages({ token, id, type }));
        })
        .finally(() => {
          setSelectedFile(null);
          setIsSending(false);
        });
  };

  return (
    <div className="client-chat-container">
      <div className="client-chat-header">
        <h3>Chat with  {name}</h3>
      </div>

      {/* {loading && <div>Loading messages...</div>} */}
      {error && <div className="error">Error: {error}</div>}

      <div className="client-chat-messages">
        {messages.map((msg, index) => {
          const formattedTime = msg.timestamp
            ? format(new Date(msg.timestamp), "hh:mm a")
            : "";

            // console.log("msg", msg);

    const isImage = msg.file_path?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
    const isPDF = msg.file_path?.match(/\.pdf$/i);
    const isDoc = msg.file_path?.match(/\.docx$/i);
    const fileUrl = msg.file_path
      ? `${process.env.REACT_APP_CHAT_ATTACHMENT_BACKEND_URL}/${msg.file_path}`
      : null;

      // console.log("fileUrl", fileUrl);

          return (
            <div key={index} className="chat-message-wrapper">
  {msg.sender === "other" && (
    <img src={IC_logo} alt="profile_image" className="chat-avatar" />
  )}

  <div
    className={`chat-message-content ${
      msg.sender === "you" ? "align-right" : "align-left"
    }`}
  >
    <div
      className={`client-chat-message ${
        msg.sender === "you" ? "user" : "provider"
      }`}
    >
      {/* <span>{msg.text}</span> */}
                  {msg.text && <span>{msg.text}</span>}
      
                  {/* Show image preview */}
              {isPDF && (
        <AttachmentDownloadClient fileUrl={fileUrl} fileName={msg.file_name} isImage={false} />
      )}
      
      {isDoc && (
        <AttachmentDownloadClient fileUrl={fileUrl} fileName={msg.file_name} isImage={false} isDoc={true} />
      )}
      
      {isImage && (
        <AttachmentDownloadClient fileUrl={fileUrl} fileName={msg.file_name} isImage={true} />
      )}
      
      
      
      
                  {/* Fallback for other files */}
                  {!isImage && !isPDF && !isDoc && msg.file_path && (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline mt-2 block"
                    >
                      📎 {msg.file_name || "Download Attachment"}
                    </a>
                  )}
    </div>
    <div className="message-timestamp">{formattedTime}</div>
  </div>
</div>

          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <div className="client-chat-input-area">
        <input
          type="text"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => dispatch(setInput(e.target.value))}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />

         {/* File Upload Button */}
  <label className="attachment-button">
    📎
    <input
      type="file"
      onChange={(e) => setSelectedFile(e.target.files[0])}
      hidden
    />
  </label>

  {/* File Preview (if selected) */}
  {selectedFile && (
    <span className="file-name-preview">
      {selectedFile.name.substring(0, 10)}{selectedFile.name.length > 10 ? "..." : ""}
    </span>
  )}
          <button onClick={handleSend} disabled={isSending}>
  {isSending ? "Sending..." : "Send"}
</button>
      </div>
    </div>
  );
};

export default ClientChat;